import React from 'react';
import PropTypes from 'prop-types';
import {findDOMNode} from "react-dom";

import Popover from 'src/core/gd-components/gd-popover/popover';
import PriorityIcon from "src/core/gd-components/priority/priority-icon/priority-icon";

export default class PrioritySelector extends React.Component {

    static propTypes = {
        onUserSelect: PropTypes.func,
        options: PropTypes.array,
        placeholder: PropTypes.string,
        value: PropTypes.number,
        disabled: PropTypes.bool,
        noEmergency: PropTypes.bool,
        noBlocker: PropTypes.bool,

        attachment: PropTypes.string,
        targetAttachment: PropTypes.string,
        targetOffset: PropTypes.string,

        onTogglePopover: PropTypes.func,

        type: PropTypes.string,
        companyId: PropTypes.string,

        inline: PropTypes.bool,

        deleteButton: PropTypes.bool,
        onReset: PropTypes.func
    }

    static defaultProps = {
        placeholder: 'Select Priority',
        disabled: false,
        attachment: "top right",
        targetAttachment: "bottom left",
        targetOffset: "-126 0",
        inline: false,
        type: "task",
        deleteButton: false,
    }

    constructor(props) {
        super(props);

        this.state = {
            showPopover: false,
            value: this.props.value
        };
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        if (this.state.value !== nextProps.value){
            this.setState({
                value: nextProps.value
            });
        }
    }

    onClickActions = (e) => {
        if (!this.props.disabled) {
            e.stopPropagation();
            const showPopover = !this.state.showPopover;
            this.setState({
                showPopover: showPopover
            });
            if (this.props.onTogglePopover) this.props.onTogglePopover(showPopover);
        }
    }

    hidePopover = (value) => {
        this.setState({
            showPopover: false,
            value: value ? value : this.state.value
        }, ()=>{
            if (this.props.onTogglePopover) this.props.onTogglePopover(false);
            if (value && this.props.onUserSelect) this.props.onUserSelect(value);
        });
    }

    onPriorityClick = (value) => {
        this.hidePopover(value);
    }

    getOptions = () => {
        let options;

        if (this.props.options) options = this.props.options;

        if (this.props.companyId) {
            options =  gd.session.companies.get(this.props.companyId).priorities.exportToOptions();
        }

        return options;
    }

    renderPopover = () => {
        const options = this.getOptions();

        const emergencyLabel = _.result(_.find(options, (o) => {return o.value === gd.const.priority.levels.emergency}), 'label');
        const bottleneckLabel = _.result(_.find(options, (o) => {return o.value === gd.const.priority.levels.blocker}), 'label');

        // no blocker for proj
        let blockerEmergency = null;
        if ((!this.props.noEmergency || !this.props.noBlocker) && this.props.type!=='project'){
            blockerEmergency = (
                <div className="priority-group">
                    {!this.props.noEmergency && <div className="priority" onClick={this.onPriorityClick.bind(this, gd.const.priority.levels.emergency)}>
                        <PriorityIcon className="priority-icon" priority={gd.const.priority.levels.emergency}/>
                        <div className="priority-name">{emergencyLabel}</div>
                    </div>}
                    {!this.props.noBlocker && <div className="priority" onClick={this.onPriorityClick.bind(this, gd.const.priority.levels.blocker)}>
                        <PriorityIcon className="priority-icon" priority={gd.const.priority.levels.blocker}/>
                        <div className="priority-name">{bottleneckLabel}</div>
                    </div>}
                </div>
            );
        }

        if (this.state.showPopover) {
            return (
                <Popover popoverClass="priority-popover"
                         className="priority-content"
                         attachment={this.props.attachment}
                         targetAttachment={this.props.targetAttachment}
                         targetOffset={this.props.targetOffset}
                         getTargetFunc={()=>findDOMNode(this)}
                         onClickOutside={()=>{this.hidePopover()}}>

                    {blockerEmergency}

                    <div className="priority-group">
                        {options.map(function(option, key){
                            if (option.value > 10 ) return null;

                            return (
                                <div key={key}
                                     className="priority"
                                     onClick={this.onPriorityClick.bind(this, option.value)}>
                                    <PriorityIcon className="priority-icon" priority={option.value}/>
                                    <div className="priority-name">{option.label}</div>
                                </div>
                            )
                        }.bind(this))}
                    </div>
                </Popover>
            );
        }
    }

    onRemoveClick = () => {
        this.onPriorityClick(5);
        if (this.props.onReset) this.props.onReset();
    }

    render() {
        const options = this.getOptions();

        let valueLabel = this.props.placeholder;
        if (this.state.value) {
            valueLabel = _.result(_.find(options, o=>o.value === this.state.value), 'label');
            if (!valueLabel) valueLabel = this.state.value;
        }

        const classes = Classes('priority-container', this.props.className, {
            disabled: this.props.disabled,
            inline: this.props.inline
        });

        const valueClasses = Classes('selected-value', 'value_' + this.state.value);

        const selectorClasses = Classes('priority-selector', {
            inline: this.props.inline,
            'not-set': !this.state.value
        });

        return (
            <div className={classes}>
                <div className={selectorClasses} onClick={this.onClickActions}>
                    <PriorityIcon className="priority-icon" priority={this.state.value}/>
                    <div className={valueClasses}>{valueLabel}</div>

                    {this.props.deleteButton &&
                    <div className="delete-icon i5-delete-circle-solid" onClick={this.onRemoveClick}> </div>}
                </div>

                {this.renderPopover()}
            </div>
        );
    }
}
